export default __webpack_public_path__ + "static/media/SIP_AGC_LOGO_2024.9b831ffe.png";